import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Loader2 } from "lucide-react";
import { type OrganizationBase } from "nautika-types";

interface OrgSelectionProps {
  open: boolean;
  organizations: OrganizationBase[];
  selectedOrgId: string;
  onSelectedOrgChange: (orgId: string) => void;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
}

export function OrgSelection({ open, organizations, selectedOrgId, onSelectedOrgChange, onConfirm, onClose, isLoading = false }: OrgSelectionProps) {
  const handleConfirmSelection = () => {
    if (selectedOrgId) {
      onConfirm();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md [&>button]:hidden" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Sélectionner une organisation</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">Vous appartenez à plusieurs organisations. Veuillez sélectionner celle que vous souhaitez gérer.</p>

          <RadioGroup value={selectedOrgId} onValueChange={onSelectedOrgChange} className="space-y-2">
            {organizations.map((org) => (
              <label key={org.id} htmlFor={org.id} className="cursor-pointer">
                <Card className={`transition-colors hover:border-primary ${selectedOrgId === org.id ? "border-primary bg-primary/5" : "border-border"}`}>
                  <CardContent className="flex items-center p-4">
                    <RadioGroupItem value={org.id} id={org.id} className="mr-3" />
                    <div className="flex-1">
                      <div className="font-medium">{org.name}</div>
                      {org.slug && <div className="text-sm text-muted-foreground">@{org.slug}</div>}
                    </div>
                  </CardContent>
                </Card>
              </label>
            ))}
          </RadioGroup>

          <Button onClick={handleConfirmSelection} disabled={!selectedOrgId || isLoading} className="w-full">
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Sélection en cours...
              </>
            ) : (
              "Confirmer la sélection"
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
